<app-company-email-templates [companyId]=CompanyID></app-company-email-templates>